module.exports = __webpack_public_path__ + "img/android-desktop-guide.c773ed4f.png";